// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__RSPcP","rotate":"styles_rotate__wjfzN"};